import React from "react";
import { Typography, Box } from "@mui/material";

const LearningCode = () => (
    <Box sx={{ padding: '20px' }}>
        <Typography variant="h5" component="h1" gutterBottom>
            Laadu Learning Code
        </Typography>
        <Typography variant="body1" paragraph>
            Laadu is dedicated to creating a safe and supportive space for all learners. By using Laadu, you agree to follow this Learning Code and our Terms of Service.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
            What Laadu is For
        </Typography>
        <Typography variant="body1" paragraph>
            Laadu is all about learning and teaching. Our tools are designed to help people study any subject, anywhere, anytime, in fun and effective ways.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
            How to Use Laadu
        </Typography>
        <Typography variant="body1" paragraph>
            When using Laadu, please:
        </Typography>
        <Typography variant="body1" component="ul" sx={{ listStyleType: 'disc', pl: 4 }}>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Be kind and respectful:</strong> Everyone is here to learn. Treat others the way you'd like to be treated. We don't allow hatred, violence, or discrimination based on race, ethnicity, religion, gender, age, sexual orientation, or disability. Bullying, racism, or harassment of any kind is not okay.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Keep it appropriate (or private):</strong> Laadu is for learners of all ages. If you're studying content with profanity (like book quotes, song lyrics, or slang) or mature topics, use your best judgment to decide if it should be public or private. Consider making mature study sets private.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Focus on learning:</strong> Laadu is for studying, not socializing. We'll remove content that's not related to learning, like social chats, blog-like posts, fan fiction, or spam with no educational value.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Respect others' work:</strong> Don't share content that violates someone else's intellectual property rights. Check out our DMCA and copyright policy for more details.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Support academic honesty:</strong> Laadu is for learning, not cheating. Don't share test banks, exam questions, or confidential course materials publicly. If you're a teacher or student and see content being used to cheat, please report it so we can take action.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Protect privacy:</strong> Don't share your own or anyone else's personal information on Laadu. Read our full privacy policy for more information.
                </Typography>
            </li>
        </Typography>

        <Typography variant="body1" paragraph>

        </Typography>

        <Typography variant="body1" paragraph>
            We rely on our community to follow these guidelines and report any content or behavior that doesn't align with them. Visit our Reporting Inappropriate Content page to learn how to report issues.
        </Typography>
        <Typography variant="body1" paragraph>
            Thank you for helping keep Laadu a positive and productive learning environment for everyone!
        </Typography>
    </Box>
);

export default LearningCode;